import React from 'react';

import { StyledSpinner, StyledSpinnerProps } from './styles';

const Spinner: React.FC<StyledSpinnerProps> = ({ ...props }) => {
  return <StyledSpinner {...props} />;
};

export default Spinner;
